/**
 * Stanford University brand colors used in the metrical tree visualization
 */
export const STANFORD_COLORS = {
  RED: '#8C1515',    // Stanford Cardinal Red
  BLACK: '#2E2D29',  // Stanford Black
  CLAY: '#8D3C1E',   // Stanford Clay
  BROWN: '#5E3032',  // Stanford Brown
  GOLD: '#B83A4B'    // Stanford Gold
};
